/**
 * @desc
 * - Directive for showing tooltip for protect rules that have no related server environment or protect enabled
 */
;(function () {
  angular
    .module('contrast.protect.rules')
    .directive('csProtectRuleEnvironment', [csProtectRuleEnvironment])

  function csProtectRuleEnvironment() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl:
        'components-org/protect-rules/cs-protect-rule-environment.html',
      scope: {
        environment: '@',
        appId: '=',
        hasServers: '=',
        hasProtect: '=',
        moveToServer: '&'
      }
    }
  }
})()
